export default {
  providerOnHold: 'provider_onhold',
  providerResume: 'provider_resume',
  requestOnHoldStatus: 'request_onhold_status',
  startedSharingScreen: 'started_sharing_screen',
  stoppedSharingScreen: 'stopped_sharing_screen',
};
